import { pollJobUntilDone } from "./PollJobUntilDone";
import { fetchRequest } from "../Fetcher";

export const runImageGenerationJob = async ({
  body
}) => {
  const { result } = await fetchRequest({
    path: `sessions/campaign-image/generate`,
    method: "POST",
    data: JSON.stringify(body),
  });

  const jobs = result?.jobs ?? [];

  const results = await Promise.all(
    jobs.map(async (job) => {
      const { campaignImageId } = job;

      await pollJobUntilDone({
        getStatus: async () => {
          const statusResponse = await fetchRequest({
            path: `sessions/campaign-image/${campaignImageId}/status`,
            method: "GET",
          });

          const data = statusResponse.result;
          const stateValue = String(data?.state ?? "").toUpperCase();

          const state = ["FAILED", "ERROR"].includes(stateValue) ? "FAILED"
            : ["SUCCEEDED", "COMPLETED", "SUCCESS", "DONE"].includes(stateValue) ? "SUCCEEDED"
            : "PENDING";

          return {
            result: {
              state,
              data: { ...data, error: data?.errors?.[0]?.message ?? "Job failed" },
            },
          };
        },
      });

      const { result } = await fetchRequest({
        path: `sessions/campaign-image/${campaignImageId}`,
        method: "GET",
      });

      return result;
    })
  );

  return results.filter(Boolean);
};